import {Client, ClientFields} from "../../../../../types/client/clientData";
import {CircularProgress, Grid} from "@mui/material";
import React, {useCallback, useEffect, useState} from "react";
import {AsyncSelect} from "../../../../../components/forms";
import {useFormContext} from "react-hook-form";
import {HttpCacheClient} from "../../../../../http/cache/client/httpCacheClient";
import {MaritalStates, Modules} from "../../../../../types/generalData";
import {HttpClient} from "src/http/client/httpClient";
import CompanyCuitSyncDialogContent
    from "../../../../../@core/layouts/components/horizontal/app-bar-content/CompanyCuitSyncDialogContent";
import ClientSummaryDialogCard
    from "../../../../../@core/layouts/components/horizontal/app-bar-content/ClientSummaryDialogCard";
import {FontSubtitleTwo} from "../../../components/SharedTypography";
import toast from "react-hot-toast";


interface PersonalMaritalProps {
    client: Client,
    onSaveFiance: (fiance: Client) => void
}


const PersonalMarital = ({client, onSaveFiance}: PersonalMaritalProps) => {
    const maritalStatus = client[ClientFields.MaritalStatusCode]
    const isMarried = maritalStatus === MaritalStates.Casado || maritalStatus === MaritalStates.Convivientes
    const [fiance, setFiance] = useState<Client>()
    const [loadingFiance, setLoadingFiance] = useState<boolean>(false)
    
    const loadMaritalStatusTypes = useCallback(() => {
        return HttpCacheClient.getEstadosCiviles();
    }, [])
    
    const { control, watch, setValue } = useFormContext()

    useEffect(() => {
        setValue(ClientFields.MaritalStatusCode, maritalStatus)
        if (client[ClientFields.PartnerCuit] && (!isMarried)) setValue(ClientFields.MaritalStatusCode, MaritalStates.Casado)
        if (client[ClientFields.MaritalStatusCode] === MaritalStates.Convivientes) setValue(ClientFields.MaritalStatusCode, MaritalStates.Convivientes)
        if (client[ClientFields.MaritalStatusCode] === MaritalStates.Casado) setValue(ClientFields.MaritalStatusCode, MaritalStates.Casado)
        if (client[ClientFields.PartnerCuit]) {
            setLoadingFiance(true)
            HttpClient.sincronizeClientByCUIT(client[ClientFields.PartnerCuit], Modules.SolicitationOnboarding).then((r) => {
                setLoadingFiance(false)
                if (!r.tieneError) {
                    setFiance(r.data)
                } else {
                    toast.error(r.descripcionError)
                }
            })
        }
    }, []);
    

    const watchMaritalStatus = watch(ClientFields.MaritalStatusCode)
    
    useEffect(() => {
        if (watchMaritalStatus !== MaritalStates.Casado || watchMaritalStatus !== MaritalStates.Convivientes)
            setFiance(undefined)
    }, [watchMaritalStatus]);
    
    
    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <FontSubtitleTwo text={'Estado Civil'} />
            </Grid>
            <Grid item xs={12}>
                <AsyncSelect control={control}
                             loadOptions={loadMaritalStatusTypes}
                             name={ClientFields.MaritalStatusCode}
                             sx={{ width: 1/8 }}
                />
            </Grid>
            {(!isMarried || !client[ClientFields.PartnerCuit]) && !loadingFiance && !fiance ?
                <Grid item xs={12}>
                        {(watchMaritalStatus === MaritalStates.Casado || watchMaritalStatus === MaritalStates.Convivientes) &&
                            <CompanyCuitSyncDialogContent subtitle={'Ingrese el CUIT de su cónyuge para sincronizar los datos con AFIP y agilizar la operación'}
                                                          onSave={(savedFiance: Client) => {
                                                              setFiance(savedFiance)
                                                              onSaveFiance(savedFiance)
                                                              setLoadingFiance(false)
                                                          }}
                                                          inline
                            />
                        }
                </Grid>
                :
                <Grid item xs={8} justifyContent={'center'} textAlign={'center'}>
                    {
                        loadingFiance ?
                            <CircularProgress color="primary" size={40} value={40} />
                            :
                            fiance && <ClientSummaryDialogCard client={fiance} />
                    }
                </Grid>
                    
            }
        </Grid>
    )
}



export default PersonalMarital